// extracted by mini-css-extract-plugin
module.exports = {"footer":"AddLezioneForm_footer__2wzYn","formContainer":"AddLezioneForm_formContainer__3ITSU"};